import React from 'react';
import './BottomBarDetail.css';

export const BottomBarDetail = () => (
  <div className="managed-bottom-bar__body">
    <div className="managed-bottom-bar__body__description">
      <p>
        Our Managed Service is reservered for those who would rather let us take
        care of some of their tougher creative decisions or who have complex
        requirements for heir video. Based on your answers so far, our Managed
        Service seems like the perfect fit!
      </p>
      <p>
        Tired of answering questions? Cut to te chase and contact us directly Or
        continue to answer all our questions to help us better understand your
        needs.
      </p>
    </div>
    <div className="managed-bottom-bar__body__list">
      <ul>
        <li>Creative Concepts</li>
        <li>Scripting</li>
        <li>Account Manager</li>
        <li>A/B Testing</li>
        <li>Total Asset Optimization</li>
      </ul>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/BottomBar/ManagedBottomBar/BottomBarDetail/BottomBarDetail.js